import { Service } from '@common/types';
import { Box, Card, Text } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials-standalone';
import { FC } from 'react';
import s from '../StartingRates.module.scss';

type ServiceCardProps = {
  service: Service;
  isLast?: boolean;
  isFirst?: boolean;
  startingPriceFormatter: (price: number) => string;
};

const ServiceCard: FC<ServiceCardProps> = ({
  service,
  isLast = false,
  startingPriceFormatter,
}) => {
  const { t } = useTranslation();

  return (
    <Card dataHook={`service-${service.id}`} className={s.serviceCard}>
      <Card.Header
        title={
          <Text
            tagName="h4"
            className={s.headerLabel}
            size="small"
            weight="normal"
          >
            {t(`explore.services.${service.displayKey}`)}
          </Text>
        }
        subtitle={
          <Text weight="thin" size="small" className={s.subtitle}>
            {t(`profile-page-${service.displayKey}-description`)}
          </Text>
        }
        suffix={
          <Box
            direction="horizontal"
            dataHook="starting-price"
            backgroundColor="#E2D8FF"
            borderRadius="2px"
            gap="3px"
            padding="3px 6px 3px 6px"
            textAlign="center"
            height="fit-content"
            alignSelf="center"
          >
            <Trans
              i18nKey="profile-page-starting-rates-from-min-price"
              values={{
                amount: startingPriceFormatter(service.minPrice),
              }}
            >
              <Text className={s.fromText} weight="thin" size="tiny">
                {t('profile-page-starting-rates-from')}
              </Text>
              <Text className={s.fromPrice} weight="thin" size="tiny">
                {startingPriceFormatter(service.minPrice)}
              </Text>
            </Trans>
          </Box>
        }
        className={s.descriptionCard}
      />
      {!isLast && <Card.Divider className={s.divider} />}
    </Card>
  );
};

export default ServiceCard;
